import script from "./PersonalCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalCenter.vue?vue&type=script&setup=true&lang=js"

import "./PersonalCenter.vue?vue&type=style&index=0&id=4bf0704e&lang=less&scoped=true"

import exportComponent from "D:\\zyr\\gptm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bf0704e"]])

export default __exports__